/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {_document as Éµangular_packages_platform_browser_platform_browser_b,errorHandler as Éµangular_packages_platform_browser_platform_browser_a} from './src/browser';
export {GenericBrowserDomAdapter as Éµangular_packages_platform_browser_platform_browser_i} from './src/browser/generic_browser_adapter';
export {SERVER_TRANSITION_PROVIDERS as Éµangular_packages_platform_browser_platform_browser_g,appInitializerFactory as Éµangular_packages_platform_browser_platform_browser_f} from './src/browser/server-transition';
export {initTransferState as Éµangular_packages_platform_browser_platform_browser_c} from './src/browser/transfer_state';
export {_createNgProbe as Éµangular_packages_platform_browser_platform_browser_h} from './src/dom/debug/ng_probe';
export {EventManagerPlugin as Éµangular_packages_platform_browser_platform_browser_d} from './src/dom/events/event_manager';
export {DomSanitizerImpl as Éµangular_packages_platform_browser_platform_browser_e} from './src/security/dom_sanitization_service';